module.exports = __webpack_public_path__ + "static/media/onlineShopping.8861255e.jpg";